import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "game-over-overlay" }
const _hoisted_2 = { class: "game-over-card" }
const _hoisted_3 = { class: "header-group" }
const _hoisted_4 = {
  key: 0,
  class: "narrator-epilogue"
}
const _hoisted_5 = { class: "epilogue-title" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "roles-reveal" }
const _hoisted_8 = { class: "team-column mafia-column" }
const _hoisted_9 = { class: "player-list" }
const _hoisted_10 = { class: "player-role" }
const _hoisted_11 = {
  key: 0,
  class: "empty-list"
}
const _hoisted_12 = { class: "team-column citizen-column" }
const _hoisted_13 = { class: "player-list" }
const _hoisted_14 = { class: "player-role" }

import { computed } from 'vue';
import { useGameStore } from '@/stores/gameStore';
import { useUserStore } from '@/stores/userStore';
import type { GameEvent } from '@/types/game';


export default /*@__PURE__*/_defineComponent({
  __name: 'GameOverScreen',
  setup(__props) {

const gameStore = useGameStore();
const userStore = useUserStore();

const isMe = (name: string) => userStore.playerName === name;

const winnerTeamText = computed(() => {
    return gameStore.room?.winner === 'mafia' ? 'Победа Мафии' : 'Победа Мирных жителей';
});

const winnerTeamClass = computed(() => {
    return gameStore.room?.winner === 'mafia' ? 'mafia-win' : 'citizens-win';
});

const mafiaTeam = computed(() => gameStore.room?.players.filter(p => p.role === 'mafia' || p.role === 'whore') || []);
const citizensTeam = computed(() => gameStore.room?.players.filter(p => p.role !== 'mafia' && p.role !== 'whore') || []);

const roleMap: Record<string, string> = {
    mafia: "Мафия", citizen: "Мирный", doctor: "Доктор", comissar: "Комиссар", whore: "Потаскуха"
};
const formatRole = (role: string | null) => role ? roleMap[role] || role : '—';

const epilogue = computed(() => {
    if (!gameStore.room?.last_events) return null;
    return gameStore.room.last_events.find((e: GameEvent) => e.type === 'game_over_narration') || null;
});

const playAgain = () => {
    gameStore.leaveRoom();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "title" }, "Игра окончена", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "divider" }, null, -1)),
        _createElementVNode("h2", {
          class: _normalizeClass(["winner-announcement", winnerTeamClass.value])
        }, _toDisplayString(winnerTeamText.value), 3)
      ]),
      (epilogue.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(epilogue.value.title), 1),
            _createElementVNode("p", {
              class: "epilogue-text",
              innerHTML: epilogue.value.narration
            }, null, 8, _hoisted_6)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "team-title" }, "Мафия", -1)),
          _createElementVNode("ul", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mafiaTeam.value, (player) => {
              return (_openBlock(), _createElementBlock("li", {
                key: player.name,
                class: "player-item"
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["player-name", { 'is-me': isMe(player.name) }])
                }, _toDisplayString(player.name), 3),
                _createElementVNode("span", _hoisted_10, _toDisplayString(formatRole(player.role)), 1)
              ]))
            }), 128)),
            (mafiaTeam.value.length === 0)
              ? (_openBlock(), _createElementBlock("li", _hoisted_11, "Никого"))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "team-title" }, "Мирные жители", -1)),
          _createElementVNode("ul", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(citizensTeam.value, (player) => {
              return (_openBlock(), _createElementBlock("li", {
                key: player.name,
                class: "player-item"
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["player-name", { 'is-me': isMe(player.name) }])
                }, _toDisplayString(player.name), 3),
                _createElementVNode("span", _hoisted_14, _toDisplayString(formatRole(player.role)), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("button", {
        onClick: playAgain,
        class: "btn primary-btn"
      }, " Вернуться в лобби ")
    ])
  ]))
}
}

})